/**
 * Chess board constants
 */
import type { File, Rank } from "@cloudnest/augmented-chess-engine";

/** All files from a to h (left to right) */
export const FILES: File[] = ["a", "b", "c", "d", "e", "f", "g", "h"];

/** All ranks from 8 to 1 (top to bottom in display) */
export const RANKS: Rank[] = [8, 7, 6, 5, 4, 3, 2, 1];

/**
 * Determines if a square should be light colored
 * CRITICAL: Uses correct formula (fileIndex + rank) % 2 === 0
 * This ensures a1 is dark and h1 is light (standard chess board)
 *
 * @param file - The file (a-h)
 * @param rank - The rank (1-8)
 * @returns true if square should be light colored
 */
export function isLightSquare(file: File, rank: Rank): boolean {
  const fileIndex = FILES.indexOf(file);
  return (fileIndex + rank) % 2 === 0;
}
